<template>
  <kst-form no-bezel class="block" v-if="access.Act_New">
    <template #top-right>
      <kst-button action-mode full-label
        class="is-primary"
        :module="Model.Module"
        :moduleType="Model.ModuleType.New"
        :urlParams="urlParams"
      />
    </template>
  </kst-form>
</template>

<script>
import Model from "../RinvModel.js";

export default {
  props: {
    invoiceId: Number
  },
  data: () => ({
    Model: Model,
    access: {}
  }),
  computed: {
    urlParams() {
      return this.$kst.Route.getParams({
        [this.$kst.Enum.Param.InvoiceID]: this.invoiceId
      });
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.access = this.$kst.Access.create(Model.Access);
    }
  }
}
</script>